/// <amd-module name="Agile/Backlogs/Directory/BacklogDirectoryConstants" />
export const AreaName = "Backlogs";
export const LOAD_DIRECTORY = "Backlogs_Start_LoadDirectoryView";
